import { createFileRoute, redirect } from "@tanstack/react-router";
import { AppShell } from "@/app/AppShell";
import { ApiError, fetchMe, qk, setActiveWorkspace } from "@/lib/api";

export const Route = createFileRoute("/$workspace")({
  beforeLoad: async ({ params, context, location }) => {
    // Every API call below this route carries Guv-Workspace.
    setActiveWorkspace(params.workspace);
    try {
      await context.queryClient.ensureQueryData({ queryKey: qk.me(), queryFn: fetchMe });
    } catch (e) {
      if (e instanceof ApiError && (e.status === 401 || e.code === "unauthorized")) {
        throw redirect({ to: "/login", search: { next: location.href } });
      }
      throw e;
    }
  },
  component: AppShell,
});
